import {
  FETCH_ALL_CAMPAIGNS,
  FETCH_ALL_CAMPAIGNS_SUCCEDD,
  FETCH_ALL_CAMPAIGNS_FAILED,
} from './action_types';

export default {
  fetchAllCampaignAction: (params, callback) => ({
    type: FETCH_ALL_CAMPAIGNS,
    params,
    callback,
  }),
  fetchAllCampaignActionSucceed: (data, totalCount, callback) => ({
    type: FETCH_ALL_CAMPAIGNS_SUCCEDD,
    params: {
      data,
      totalCount,
      callback,
    },
  }),
  fetchAllCampaignActionFailed: (err) => ({
    type: FETCH_ALL_CAMPAIGNS_FAILED,
    err,
  }),
};
